
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import dayjs from 'dayjs'

@Component
export default class CountDown extends Vue {
  @Prop({ default: '2023/1/9 18:30:51' }) times!: string

  date = 0

  @Watch('times', { immediate: true })
  handleDate() {
    let date = dayjs(this.times).format('YYYY/MM/DD HH:mm:ss')
    this.date = new Date(date).getTime() - new Date().getTime()
    console.log('this', this.date)
  }
}
